<div class="phasesToolbarContainer">
  <div class="phaseLineContainer"></div>

  <div *ngFor="let phase of phases;let i=index;">
   

    <div *ngIf="phase.visible" class="singlePhaseContainer" [ngStyle]="{'width': singlePhaseWidth + '%' }" (click)="onClick(phase)">
      <div class="topContainer">
        <div class="phaseNumberContainer" [ngClass]="{'phaseNotAllowed': phase.done == false && phase.firstUndone==false, 'pointer': phase.done == true && phase.current==false }">
          <div class="phaseNumberInsideContainer" [ngClass]="{'firstPhaseUndone': phase.firstUndone == true, 'phaseCurrent': phase.current == true, 'phaseDone' : phase.done == true }">
            <span [ngClass]="{'phaseCurrent': phase.current == true }">{{(i+1)}}</span>
          </div>
        </div>   
      </div>
      <div class="bottomContainer">
        <div class="phaseDescriptionContainer" [ngClass]="{'phaseCurrent': phase.current == true, 'phaseDone' : phase.done == true }" style="cursor:pointer">{{phase.description}}</div>
      </div>  
    </div>

    <div class="clear_fix"></div>

  </div>

 
</div>


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/components/phases-toolbar/phases-toolbar.component.html